<template>
	<div class="p-t-70 bgc-f4f4f4 p-30">
		<div class="bgc-white br-20 w-100p h-100p m-t-20">
			<div class="d-flex-center f-24 c-00 p-t-50 font-weight-bold">长按二维码</div>
			<div class="d-flex-center f-24 c-00 m-t-20 font-weight-bold">下载app进行注册登录</div>
			<div class="d-flex-center m-t-20">
				<img src="../assets/image/index/er.png" class="w-150 h-150" />
			</div>
			<div class="d-flex-center f-24 c-00 m-t-20 font-weight-bold">
				下载润寓app
			</div>
			<div class="f-14 c-99 m-t-20 d-flex-center">
				或者手机软件商店搜索润寓app
			</div>
			<div class="f-14 c-99 d-flex-center">
				进行软件下载
			</div>
			<div class="d-flex-center">
				<div class="b-b m-t-20 w-80p">
				</div>
			</div>
			<div class="d-flex-center p-t-20 p-b-20">
				<img src="../assets/image/index/logo-bai.png"/>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		methods: {

		}
	}
</script>

<style>
</style>
